import type { BroadcastContextValue } from "./broadcast.type";

import { createContext, useContext } from "react";

const config = {
  contextName: "BroadcastContext",
  providerName: "BroadcastProvider",
};

export const BroadcastContext = createContext<BroadcastContextValue | null>(
  null
);

export const useBroadcastContext = () => {
  const contextValue = useContext(BroadcastContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
